module.exports = __webpack_public_path__ + "img/collection-weddingRingsMokumeGane.1fc0b47.webp";